import Cookies from 'js-cookie';

export const initial = Cookies.getJSON();

export const set = (state, cookie) => ({
    ...state, [cookie.name]: cookie.value,
});

export const remove = (state, name) => ({
    ...state, [name]: undefined,
});



// WEBPACK FOOTER //
// ./app/reducers/cookie.js